module.exports = __webpack_public_path__ + "img/img-shop-food-3.d03e9d4e.png";